class CartIconBubble extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector('button');
    this.cartDrawer = document.querySelector('cart-drawer');
    if (this.cartDrawer) {
      this.toggleButton.addEventListener('click', this.toggle.bind(this));
    }
  }
  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    document.body.classList.contains(this.cartDrawer.activeClass)
    ? this.cartDrawer.close() 
    : this.cartDrawer.open();
  }
}

if (!customElements.get('cart-icon-bubble')) {
  customElements.define('cart-icon-bubble', CartIconBubble);
}